// extracted by mini-css-extract-plugin
export default {"page":"Dashboard_page__R2WeS","midRow":"Dashboard_midRow__6LBKe","bottomRow":"Dashboard_bottomRow__UtGxD"};